"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniversalSearchListResponseSchema = exports.UniversalSearchCountSchema = exports.UniversalSearchMapResponseSchema = exports.NoResultBannerSchema = void 0;
var zod_1 = require("zod");
var product_unit_1 = require("../product-unit");
var UniversalListItemSchema = zod_1.z.discriminatedUnion('type', [
    product_unit_1.ProductUnitSchema,
    product_unit_1.RelatedKeywordSchema,
    product_unit_1.OmBannerSchema,
    product_unit_1.SectionDividerSchema,
    product_unit_1.SectionGroupHeaderSchema,
    product_unit_1.ConversationalInformationDiscoveryWidgetSchema,
]);
exports.NoResultBannerSchema = zod_1.z.object({
    type: zod_1.z.enum(['FLIGHT', 'GLOBAL_TNA']),
    action: zod_1.z.object({ app: zod_1.z.string(), web: zod_1.z.string() }),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
/**
 * LIST API - 통합 SRP 지도뷰 조회 응답
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-list-api#tag/universal-search-v1/paths/~1universal-search~1v1~1map-view/post}
 * GLOBAL API - 해외숙소 지도뷰 조회 응답
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-global-list-api#tag/universal-search-v1/paths/~1universal-search~1v1~1map-view/post}
 */
exports.UniversalSearchMapResponseSchema = zod_1.z.object({
    items: zod_1.z.array(product_unit_1.ProductUnitSchema).nullish(),
    paging: zod_1.z.object({ current: zod_1.z.number(), isLast: zod_1.z.boolean(), total: zod_1.z.number() }).nullish(),
    noProductResult: zod_1.z.boolean().nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
/**
 * 통합 SRP 글로벌 필터 CTA 버튼 개수 조회 응답
 * @see {@link https://fe-api-doc.dev.yanolja.in/?api=cx-list-api#tag/universal-search-v1/paths/~1universal-search~1v1~1count/post}
 */
exports.UniversalSearchCountSchema = zod_1.z.object({
    count: zod_1.z.number().nullish(),
    text: zod_1.z.string(),
    enabled: zod_1.z.boolean(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
});
exports.UniversalSearchListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(UniversalListItemSchema),
    paging: zod_1.z
        .object({
        current: zod_1.z.number().nullish(),
        isLast: zod_1.z.boolean(),
        total: zod_1.z.number().nullish(),
        cursor: zod_1.z.string().nullish(),
    })
        .nullish(),
    serverLogMeta: zod_1.z.record(zod_1.z.unknown()).nullish(),
    noProductResult: zod_1.z.boolean().nullish(),
    spellCorrection: zod_1.z.string().nullish(),
    noResultBanners: zod_1.z.array(exports.NoResultBannerSchema).nullish(),
});
